import React from "react";
import "./AppHeader.scss"

function AppHeader() {
  return (
    <header className="has-bg-dark">
      <div className="container has-py-2">
        <h1 className="has-my-1">QR Code</h1>
      </div>
    </header>
  );
}

export default AppHeader;